export default __webpack_public_path__ + "static/media/order-placed.ed8a1b21.svg";